<div class="wizard-wrapper glass-wizard">

  <!-- ── BARRA SUPERIOR INTEGRADA (Sin fondo ni borde divisorio) ── -->
  <div class="integrated-top-bar" [class.substep-bar-active]="subStep !== ''">
    <button class="wiz-back-btn" (click)="dismiss()" [attr.aria-label]="subStep !== '' ? 'Volver' : 'Cerrar'">
      <ion-icon [name]="subStep !== '' ? 'arrow-back-outline' : 'close'"></ion-icon>
    </button>

    <!-- Barra de progreso visual (Durante el Wizard de creación/edición) -->
    <div class="progress-track" *ngIf="currentStep > 0 && subStep === ''">
      <div class="progress-fill" [style.width.%]="(currentStep / totalSteps) * 100"></div>
    </div>

    <span class="step-counter" *ngIf="currentStep > 0 && subStep === ''">{{ currentStep }}/{{ totalSteps }}</span>

    <!-- Título simple cuando estamos en paso 0 sin sub-paso -->
    <span class="step-counter" *ngIf="currentStep === 0 && subStep === ''">Gestión de Ítems</span>

    <!-- Título y descripción integrados cuando estamos en un sub-paso -->
    <div class="header-substep-content animate-fade" *ngIf="subStep !== ''">
      <div class="hsc-text">
        <h2 class="hsc-title">
          {{ subStep === 'medidas' ? 'Cantidades y Medidas' : (subStep === 'fotos' ? 'Fotos del Ítem' : 'Estimación y Notas') }}
        </h2>
        <p class="hsc-hint">
          {{ subStep === 'medidas' ? 'Registre superficies, longitudes y unidades del ítem' : (subStep === 'fotos' ?
          'Capture y adjunte evidencia fotográfica del ítem' : 'Planilla, materiales, subcontratos y estimados') }}
        </p>
      </div>
    </div>
  </div>

  <!-- ── CONTENIDO DEL MODAL ─────────────────────────────────────────── -->
  <ion-content class="wizard-content">
    <div class="wizard-body">

      <!-- ══════════ PASO 0 — INICIO / RESUMEN DEL ÍTEM ══════════ -->
      <div class="step-panel" *ngIf="currentStep === 0 && subStep === ''">

        <div class="step-input-area step-summary-area-v2">

          <!-- Ubicación destacada arriba como elemento principal -->
          <div class="area-location-banner" *ngIf="lugarNombre">
            <div class="alb-icon">
              <ion-icon name="location"></ion-icon>
            </div>
            <div class="alb-content">
              <span class="alb-label">Lugar / Ubicación</span>
              <span class="alb-name">{{ lugarNombre }}</span>
            </div>
          </div>

          <!-- ── NAVEGADOR ENTRE ÍTEMS (FLECHAS A LOS EXTREMOS + CONTADOR CENTRAL) ── -->
          <div class="area-nav-banner" *ngIf="areasList && areasList.length > 0">
            <button class="anb-arrow-btn" (click)="prevRegisteredArea()" [disabled]="areasList.length <= 1"
              aria-label="Ítem anterior">
              <ion-icon name="chevron-back"></ion-icon>
            </button>
            <div class="anb-indicator">
              <span class="anb-current">{{ currentAreaIndex + 1 }}</span>
              <span class="anb-divider">de</span>
              <span class="anb-total">{{ areasList.length }}</span>
              <span class="anb-label">{{ areasList.length === 1 ? 'ítem registrado' : 'ítems registrados' }}</span>
            </div>
            <button class="anb-arrow-btn" (click)="nextRegisteredArea()" [disabled]="areasList.length <= 1"
              aria-label="Ítem siguiente">
              <ion-icon name="chevron-forward"></ion-icon>
            </button>
          </div>

          <!-- Resumen e información del ítem activo (tocar para editar datos principales) -->
          <div class="area-active-summary clickable" *ngIf="formData.comentario || selectedAreas.length > 0" (click)="currentStep = 1">
            <div class="aas-content">
              <!-- Descripción principal del ítem destacada como título -->
              <div class="aas-main-title">
                <ion-icon name="document-text-outline" class="item-main-icon"></ion-icon>
                <span class="item-desc-text">{{ formData.comentario || 'Ítem sin descripción' }}</span>
              </div>

              <!-- Categorización: Áreas y Estructuras asignadas -->
              <div class="aas-categories-row">
                <div class="aas-cat-badge area-cat" *ngIf="selectedAreas.length > 0">
                  <ion-icon name="map-outline"></ion-icon>
                  <span>
                    <ng-container *ngFor="let a of selectedAreas; let last = last">{{ a.nombre }}{{ !last ? ', ' : '' }}</ng-container>
                  </span>
                </div>
                <div class="aas-cat-badge struct-cat" *ngIf="selectedEstructuras.length > 0">
                  <ion-icon name="construct-outline"></ion-icon>
                  <span>
                    <ng-container *ngFor="let e of selectedEstructuras; let last = last">{{ e.nombre }}{{ !last ? ', ' : '' }}</ng-container>
                  </span>
                </div>
              </div>
            </div>
            <div class="aas-actions">
              <button type="button" class="aas-action-btn delete" (click)="$event.stopPropagation(); deleteArea()" title="Eliminar ítem">
                <ion-icon name="trash-outline"></ion-icon>
              </button>
            </div>
          </div>

          <!-- ── OPCIONES COMPACTAS (PILL GRID) ── -->
          <div class="area-options-grid">
            <div class="area-option-pill" (click)="enterSubStep('medidas')">
              <div class="aop-icon blue">
                <ion-icon name="resize-outline"></ion-icon>
              </div>
              <div class="aop-text">
                <span class="aop-title">Medidas</span>
                <span class="aop-count" *ngIf="areaCounts.medidas > 0">
                  {{ areaCounts.medidas }} reg.<ng-container *ngIf="areaCounts.totalM2 > 0"> · {{ areaCounts.totalM2 |
                    number:'1.2-2' }} m²</ng-container>
                </span>
                <span class="aop-count empty" *ngIf="areaCounts.medidas === 0">Sin datos</span>
              </div>
              <ion-icon name="chevron-forward-outline" class="aop-arrow"></ion-icon>
            </div>

            <div class="area-option-pill" (click)="enterSubStep('fotos')">
              <div class="aop-icon purple">
                <ion-icon name="camera-outline"></ion-icon>
              </div>
              <div class="aop-text">
                <span class="aop-title">Fotos</span>
                <span class="aop-count" *ngIf="areaCounts.fotos > 0">{{ areaCounts.fotos }} fotos</span>
                <span class="aop-count empty" *ngIf="areaCounts.fotos === 0">Sin fotos</span>
              </div>
              <ion-icon name="chevron-forward-outline" class="aop-arrow"></ion-icon>
            </div>

            <div class="area-option-pill" (click)="enterSubStep('notas')">
              <div class="aop-icon amber">
                <ion-icon name="document-text-outline"></ion-icon>
              </div>
              <div class="aop-text">
                <span class="aop-title">Estimación y Notas</span>
                <span class="aop-count" *ngIf="areaCounts.totalEstimadoMonto > 0 || areaCounts.cantidadNotas > 0">
                  <ng-container *ngIf="areaCounts.totalEstimadoMonto > 0">Estimado: ${{ areaCounts.totalEstimadoMonto | number:'1.2-2' }}</ng-container>
                  <ng-container *ngIf="areaCounts.totalEstimadoMonto === 0 && areaCounts.cantidadNotas > 0">Sin estimado</ng-container>
                  <ng-container *ngIf="areaCounts.cantidadNotas > 0"><ng-container *ngIf="areaCounts.totalEstimadoMonto > 0"> · </ng-container>Notas: {{ areaCounts.cantidadNotas }}</ng-container>
                </span>
                <span class="aop-count empty" *ngIf="areaCounts.totalEstimadoMonto === 0 && areaCounts.cantidadNotas === 0">Sin registros</span>
              </div>
              <ion-icon name="chevron-forward-outline" class="aop-arrow"></ion-icon>
            </div>
          </div>

        </div>
      </div>

      <!-- ══════════ PASO 1 — DESCRIPCIÓN DEL ÍTEM ══════════ -->
      <div class="step-panel" *ngIf="currentStep === 1">
        <!-- Contexto de ubicación superior independiente -->
        <div class="wizard-location-context" *ngIf="lugarNombre">
          <div class="wlc-icon-wrap">
            <ion-icon name="pin"></ion-icon>
          </div>
          <div class="wlc-text">
            <span class="wlc-label">Inspeccionando en</span>
            <span class="wlc-name">{{ lugarNombre }}</span>
          </div>
        </div>

        <div class="step-header">
          <div class="step-illustration observaciones">
            <ion-icon name="document-text"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">Descripción del Ítem</h2>
            <p class="step-hint">Detalles, daños u observaciones que evaluará este ítem</p>
          </div>
        </div>

        <div class="step-input-area">
          <div class="premium-input-wrapper textarea-mode">
            <textarea rows="6" class="ac-input" [(ngModel)]="formData.comentario"
              placeholder="Ej: Pintura en paredes y reparación de filtraciones en el cielo raso de gypsum del baño de colaboradores..."></textarea>
          </div>

          <div class="ai-assist-note" *ngIf="mode === 'add' && !areaSaved && formData.comentario">
            <ion-icon name="sparkles"></ion-icon>
            <span>Al continuar, la IA analizará esta descripción para sugerirte las áreas y estructuras más adecuadas para este ítem.</span>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 2 — CATEGORIZACIÓN: ÁREAS ══════════ -->
      <div class="step-panel" *ngIf="currentStep === 2">
        <!-- Contexto de ubicación superior independiente -->
        <div class="wizard-location-context" *ngIf="lugarNombre">
          <div class="wlc-icon-wrap">
            <ion-icon name="pin"></ion-icon>
          </div>
          <div class="wlc-text">
            <span class="wlc-label">Inspeccionando en</span>
            <span class="wlc-name">{{ lugarNombre }}</span>
          </div>
        </div>

        <div class="step-header">
          <div class="step-illustration area">
            <ion-icon name="map"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">¿A qué áreas pertenece este ítem?</h2>
            <p class="step-hint">Categorice las áreas físicas vinculadas a este ítem</p>
          </div>
        </div>

        <!-- Sugerencias de Áreas generadas por IA (solo en creación de ítem nuevo) -->
        <div class="frequent-section" *ngIf="mode === 'add' && !areaSaved && aiSugeridasAreas.length > 0">
          <div class="freq-title">
            <ion-icon name="sparkles"></ion-icon>
            <span>Sugerencias de IA según tu descripción:</span>
          </div>
          <div class="freq-chips">
            <div class="freq-chip" *ngFor="let a of aiSugeridasAreas" (click)="toggleArea(a)" [class.selected]="isAreaSelected(a)">
              <div class="freq-avatar area">
                <ion-icon [name]="isAreaSelected(a) ? 'checkmark' : 'add'"></ion-icon>
              </div>
              <span>{{ a.nombre }}</span>
            </div>
          </div>
        </div>

        <!-- Mensaje cuando la IA no detectó un área específica -->
        <div class="ai-no-match-card" *ngIf="mode === 'add' && !areaSaved && lastAnalyzedComentario && aiSugeridasAreas.length === 0">
          <div class="anm-icon-box">
            <ion-icon name="information-circle-outline"></ion-icon>
          </div>
          <div class="anm-texts">
            <span class="anm-title">No se detectó un área específica</span>
            <span class="anm-desc">La IA determinó que la descripción no corresponde a un área física específica. Por favor selecciona o registra el área manualmente a continuación.</span>
            <span class="anm-reason" *ngIf="aiRazon">💡 {{ aiRazon }}</span>
          </div>
        </div>

        <div class="step-input-area">
          <!-- Estado 1: Sin selección previa -> Toca para seleccionar -->
          <div class="big-input-box" *ngIf="selectedAreas.length === 0" (click)="openAreaSelector()">
            <ion-icon name="map-outline" class="bi-search"></ion-icon>
            <div class="big-input">
              <span style="color: rgba(255, 255, 255, 0.7); font-weight: 500;">Toca para seleccionar área...</span>
            </div>
            <ion-icon name="chevron-forward-outline"
              style="color: rgba(255, 255, 255, 0.85); font-size: 1.2rem; flex-shrink: 0;"></ion-icon>
          </div>

          <!-- Estado 2: Con selección -> Tarjeta completa que muestra todas las áreas -->
          <div class="interactive-selection-card" *ngIf="selectedAreas.length > 0" (click)="openAreaSelector()">
            <!-- Fila Superior: Ícono + Categoría/Contador -->
            <div class="isc-top-row">
              <div class="isc-header-group">
                <div class="isc-avatar">
                  <ion-icon name="map-outline"></ion-icon>
                </div>
                <div class="isc-meta">
                  <span class="isc-category">Áreas Asignadas al Ítem</span>
                  <span class="isc-count-badge">
                    {{ selectedAreas.length }} {{ selectedAreas.length === 1 ? 'área asignada' : 'áreas asignadas' }}
                  </span>
                </div>
              </div>
              <ion-icon name="chevron-forward-outline"
                style="color: rgba(255, 255, 255, 0.75); font-size: 1.3rem; flex-shrink: 0;"></ion-icon>
            </div>

            <!-- Listado visible de todas las áreas seleccionadas (Chips envolventes) -->
            <div class="isc-items-chips">
              <div class="isc-chip" *ngFor="let a of selectedAreas">
                <ion-icon name="map-outline"></ion-icon>
                <span>{{ a.nombre }}</span>
              </div>
            </div>

            <span class="isc-hint">
              <ion-icon name="options-outline"></ion-icon>
              Toca para cambiar, agregar o quitar áreas
            </span>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 3 — CATEGORIZACIÓN: ESTRUCTURAS ══════════ -->
      <div class="step-panel" *ngIf="currentStep === 3">
        <!-- Contexto de ubicación superior independiente -->
        <div class="wizard-location-context" *ngIf="lugarNombre">
          <div class="wlc-icon-wrap">
            <ion-icon name="pin"></ion-icon>
          </div>
          <div class="wlc-text">
            <span class="wlc-label">Inspeccionando en</span>
            <span class="wlc-name">{{ lugarNombre }}</span>
          </div>
        </div>

        <div class="step-header">
          <div class="step-illustration estructura">
            <ion-icon name="construct"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">¿Qué estructuras aplican a este ítem?</h2>
            <p class="step-hint">Categorice las estructuras constructivas del ítem</p>
          </div>
        </div>

        <!-- Sugerencias de Estructuras generadas por IA (solo en creación de ítem nuevo) -->
        <div class="frequent-section" *ngIf="mode === 'add' && !areaSaved && aiSugeridasEstructuras.length > 0">
          <div class="freq-title">
            <ion-icon name="sparkles"></ion-icon>
            <span>Sugerencias de IA según tu descripción:</span>
          </div>
          <div class="freq-chips">
            <div class="freq-chip" *ngFor="let est of aiSugeridasEstructuras" (click)="toggleEstructura(est)" [class.selected]="isEstructuraSelected(est)">
              <div class="freq-avatar estructura">
                <ion-icon [name]="isEstructuraSelected(est) ? 'checkmark' : 'add'"></ion-icon>
              </div>
              <span>{{ est.nombre }}</span>
            </div>
          </div>
        </div>

        <div class="step-input-area">
          <!-- Estado 1: Sin selección previa -> Toca para seleccionar -->
          <div class="big-input-box" *ngIf="selectedEstructuras.length === 0" (click)="openEstructuraSelector()">
            <ion-icon name="construct-outline" class="bi-search"></ion-icon>
            <div class="big-input">
              <span style="color: rgba(255, 255, 255, 0.7); font-weight: 500;">Toca para seleccionar estructuras...</span>
            </div>
            <ion-icon name="chevron-forward-outline"
              style="color: rgba(255, 255, 255, 0.85); font-size: 1.2rem; flex-shrink: 0;"></ion-icon>
          </div>

          <!-- Estado 2: Con selección -> Tarjeta completa que muestra todas las estructuras -->
          <div class="interactive-selection-card" *ngIf="selectedEstructuras.length > 0"
            (click)="openEstructuraSelector()">
            <!-- Fila Superior: Ícono + Categoría/Contador -->
            <div class="isc-top-row">
              <div class="isc-header-group">
                <div class="isc-avatar">
                  <ion-icon name="construct-outline"></ion-icon>
                </div>
                <div class="isc-meta">
                  <span class="isc-category">Estructuras Asignadas al Ítem</span>
                  <span class="isc-count-badge">
                    {{ selectedEstructuras.length }} {{ selectedEstructuras.length === 1 ? 'estructura asignada' :
                    'estructuras asignadas' }}
                  </span>
                </div>
              </div>
              <ion-icon name="chevron-forward-outline"
                style="color: rgba(255, 255, 255, 0.75); font-size: 1.3rem; flex-shrink: 0;"></ion-icon>
            </div>

            <!-- Listado visible de todas las estructuras seleccionadas (Chips envolventes) -->
            <div class="isc-items-chips">
              <div class="isc-chip" *ngFor="let est of selectedEstructuras">
                <ion-icon name="layers-outline"></ion-icon>
                <span>{{ est.nombre }}</span>
              </div>
            </div>

            <span class="isc-hint">
              <ion-icon name="options-outline"></ion-icon>
              Toca para cambiar, agregar o quitar estructuras
            </span>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 4 — RESUMEN FINAL DEL ÍTEM ══════════ -->
      <div class="step-panel" *ngIf="currentStep === 4">
        <div class="step-header">
          <div class="step-illustration resumen">
            <ion-icon name="checkmark-done-circle"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">Resumen del Ítem</h2>
            <p class="step-hint">Verifique los datos antes de guardar y continuar con medidas, fotos y estimaciones</p>
          </div>
        </div>

        <div class="step-input-area">
          <div class="summary-card">
            <div class="summary-title">Datos del Ítem a Registrar</div>

            <div class="summary-row" *ngIf="lugarNombre">
              <ion-icon name="pin-outline"></ion-icon>
              <span><strong>Ubicación:</strong> {{ lugarNombre }}</span>
            </div>

            <div class="summary-row clickable-row" (click)="currentStep = 1">
              <ion-icon name="document-text-outline"></ion-icon>
              <div class="row-text-content">
                <strong>Descripción del Ítem:</strong>
                <p class="summary-desc-text">{{ formData.comentario || 'Sin descripción' }}</p>
              </div>
              <ion-icon name="create-outline" class="row-edit-icon"></ion-icon>
            </div>

            <div class="summary-row clickable-row" (click)="currentStep = 2">
              <ion-icon name="map-outline"></ion-icon>
              <div class="row-text-content">
                <strong>Áreas Categorizadas ({{ selectedAreas.length }}):</strong>
                <div class="summary-chips-wrap">
                  <span class="summary-chip" *ngFor="let a of selectedAreas">{{ a.nombre }}</span>
                </div>
              </div>
              <ion-icon name="create-outline" class="row-edit-icon"></ion-icon>
            </div>

            <div class="summary-row clickable-row" (click)="currentStep = 3">
              <ion-icon name="construct-outline"></ion-icon>
              <div class="row-text-content">
                <strong>Estructuras Categorizadas ({{ selectedEstructuras.length }}):</strong>
                <div class="summary-chips-wrap" *ngIf="selectedEstructuras.length > 0">
                  <span class="summary-chip" *ngFor="let e of selectedEstructuras">{{ e.nombre }}</span>
                </div>
                <span *ngIf="selectedEstructuras.length === 0" style="opacity: 0.7; font-size: 0.85rem;">Ninguna seleccionada</span>
              </div>
              <ion-icon name="create-outline" class="row-edit-icon"></ion-icon>
            </div>
          </div>
        </div>
      </div>



      <!-- ══════════ SUB-PASOS (Accesibles desde Paso 0 o Paso 4) ══════════ -->
      <div class="step-panel" *ngIf="subStep !== ''">
        <ng-container *ngIf="subStep === 'medidas'">
          <div class="s4-items-wrapper">
            <!-- Rótulo: Registrar Por -->
            <div class="substep-section-heading">
              <ion-icon name="add-circle-outline"></ion-icon>
              <span>Registrar Por:</span>
            </div>

            <!-- Selector horizontal compacto y premium de tipos de medida -->
            <div class="medidas-type-strip">
              <!-- Metros Lineales -->
              <button type="button" class="medida-pill-btn" (click)="openAddMedida('lineal')">
                <div class="mp-icon">
                  <ion-icon name="resize-outline"></ion-icon>
                </div>
                <div class="mp-text-block">
                  <span class="mp-unit">Metros</span>
                  <span class="mp-type">Lineales</span>
                </div>
              </button>

              <!-- Metros Cuadrados -->
              <button type="button" class="medida-pill-btn" (click)="openAddMedida('cuadrada')">
                <div class="mp-icon">
                  <ion-icon name="grid-outline"></ion-icon>
                </div>
                <div class="mp-text-block">
                  <span class="mp-unit">Metros</span>
                  <span class="mp-type">Cuadrados</span>
                </div>
              </button>

              <!-- Unidad -->
              <button type="button" class="medida-pill-btn" (click)="openAddMedida('unidad')">
                <div class="mp-icon">
                  <ion-icon name="apps-outline"></ion-icon>
                </div>
                <div class="mp-text-block">
                  <span class="mp-type">Unidad</span>
                </div>
              </button>
            </div>

            <!-- Spinner de carga limpio sin recuadro -->
            <div *ngIf="loadingItems" class="s4-loading-container">
              <ion-spinner name="crescent" class="s4-spinner"></ion-spinner>
            </div>

            <!-- Rótulo: Resumen por Categoría -->
            <div class="substep-section-heading list-heading" *ngIf="!loadingItems && groupedMedidaTypes.length > 0">
              <ion-icon name="folder-open-outline"></ion-icon>
              <span>Resumen por Categoría:</span>
              <span class="heading-badge">{{ groupedMedidaTypes.length }}</span>
            </div>

            <!-- Carrusel Horizontal de Categorías de Medida Registradas -->
            <div class="s4-type-carousel" *ngIf="!loadingItems && groupedMedidaTypes.length > 0">
              <div class="s4-type-card" *ngFor="let g of groupedMedidaTypes" 
                   [class.active]="selectedMedidaTipo === g.key" 
                   (click)="selectMedidaTipo(g.key)">
                <div class="stc-header">
                  <div class="stc-icon" [ngClass]="g.key">
                    <ion-icon [name]="g.icon"></ion-icon>
                  </div>
                  <span class="stc-badge">{{ g.count }} {{ g.count === 1 ? 'item' : 'items' }}</span>
                </div>
                <div class="stc-body">
                  <span class="stc-label">{{ g.label }}</span>
                  <span class="stc-monto">
                    {{ g.totalValor | number:'1.2-2' }} <span style="font-size: 0.76rem; font-weight: 700; opacity: 0.85;">{{ g.displayUnit }}</span>
                  </span>
                </div>
              </div>
            </div>

            <!-- Empty state -->
            <div class="s4-empty-state" *ngIf="!loadingItems && areaItems.length === 0">
              <ion-icon name="resize-outline"></ion-icon>
              <p>Sin medidas registradas aún</p>
            </div>

            <!-- Rótulo: Detalle de Ítems -->
            <div class="substep-section-heading list-heading" *ngIf="!loadingItems && filteredMedidaItems.length > 0">
              <ion-icon name="list-outline"></ion-icon>
              <span>Detalle de {{ selectedMedidaTipo === 'cuadrada' ? 'Metros Cuadrados' : (selectedMedidaTipo === 'lineal' ? 'Metros Lineales' : 'Unidades') }}:</span>
              <span class="heading-badge">{{ filteredMedidaItems.length }}</span>
            </div>

            <!-- Lista de medidas filtrada -->
            <div class="s4-item-list" *ngIf="!loadingItems && filteredMedidaItems.length > 0">
              <div class="s4-item-card" *ngFor="let item of filteredMedidaItems" (click)="openEditMedida(item)"
                style="cursor: pointer;">
                <div class="s4-item-icon blue">
                  <ion-icon name="resize-outline"></ion-icon>
                </div>
                <div class="s4-item-info">
                  <span class="s4-item-title">{{ item.descripcion || 'Sin descripción' }}</span>
                  <span class="s4-item-sub">
                    <ng-container [ngSwitch]="item.tipo_medida">
                      <ng-container *ngSwitchCase="'cuadrada'">
                        <ng-container *ngIf="item.alto > 0">
                          {{ item.cantidad }}x · {{ item.ancho }} × {{ item.alto }} {{ item.unidad }} ({{ (item.area ||
                          (item.ancho * item.alto * item.cantidad)) | number:'1.2-2' }} {{ item.unidad }})
                        </ng-container>
                        <ng-container *ngIf="!item.alto || item.alto <= 0">
                          {{ item.cantidad > 1 ? item.cantidad + 'x · ' : '' }}{{ ((item.ancho > 0 ? item.ancho :
                          (item.area / (item.cantidad || 1)))) | number:'1.2-2' }} {{ item.unidad }} directo{{
                          item.cantidad > 1 ? ' (Total: ' + (item.area | number:'1.2-2') + ' ' + item.unidad + ')' : ''
                          }}
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'lineal'">
                        {{ item.cantidad }}x · {{ item.ancho }} {{ item.unidad }}{{ item.cantidad > 1 ? ' (Total: ' +
                        ((item.area || (item.ancho * item.cantidad)) | number:'1.2-2') + ' ' + item.unidad + ')' : '' }}
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        {{ item.cantidad }} {{ item.unidad }}
                      </ng-container>
                    </ng-container>
                  </span>
                  <span class="s4-item-comment" *ngIf="item.comentario">
                    <ion-icon name="chatbox-ellipses-outline"></ion-icon>
                    <span>{{ item.comentario }}</span>
                  </span>
                </div>
                <ion-button fill="clear" (click)="$event.stopPropagation(); deleteAreaItem(item)">
                  <ion-icon name="trash-outline" color="danger" slot="icon-only"></ion-icon>
                </ion-button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- ── SUB-PASO: Fotos ── -->
        <ng-container *ngIf="subStep === 'fotos'">
          <div class="s4-items-wrapper">
            <!-- Selector de Foto: Cámara y Galería arriba -->
            <div class="substep-section-heading">
              <ion-icon name="camera-outline"></ion-icon>
              <span>Agregar Evidencia Fotográfica:</span>
            </div>

            <div class="photo-pickers-row">
              <button type="button" (click)="processAreaPhoto('camera')" class="photo-option-btn camera-btn">
                <div class="pob-icon-wrap">
                  <ion-icon name="camera"></ion-icon>
                </div>
                <span>Cámara</span>
              </button>
              <button type="button" (click)="processAreaPhoto('photos')" class="photo-option-btn gallery-btn">
                <div class="pob-icon-wrap">
                  <ion-icon name="images"></ion-icon>
                </div>
                <span>Galería</span>
              </button>
            </div>

            <!-- Spinner de carga -->
            <div *ngIf="loadingItems" class="s4-loading-container">
              <ion-spinner name="crescent" class="s4-spinner"></ion-spinner>
            </div>

            <!-- Empty state -->
            <div class="s4-empty-state" *ngIf="!loadingItems && areaItems.length === 0">
              <ion-icon name="image-outline"></ion-icon>
              <p>Sin fotos registradas aún</p>
            </div>

            <!-- Mosaico de fotos registradas (Estilo GaleriaTrabajosComponent) -->
            <div class="substep-section-heading list-heading" *ngIf="!loadingItems && areaItems.length > 0">
              <ion-icon name="images-outline"></ion-icon>
              <span>Fotos Registradas ({{ areaItems.length }}):</span>
            </div>

            <div class="area-fotos-mosaic" *ngIf="!loadingItems && areaItems.length > 0">
              <div *ngFor="let item of areaItems" class="area-foto-card" (click)="viewAreaPhoto(item)">
                <div class="area-foto-container">
                  <img *ngIf="item.base64" [src]="item.base64" alt="Evidencia" class="area-foto-img" />
                  
                  <div class="area-foto-loading" *ngIf="item.loadingImg && !item.base64">
                    <ion-spinner name="crescent"></ion-spinner>
                  </div>

                  <div class="area-foto-loading" *ngIf="!item.loadingImg && !item.base64">
                    <ion-icon name="image-outline" style="font-size: 1.5rem; opacity: 0.6; color: #fff;"></ion-icon>
                  </div>
                  
                  <!-- Overlay inferior con fecha y texto -->
                  <div class="area-foto-overlay">
                    <span class="afo-date" *ngIf="item.created_at">{{ item.created_at | date:'dd/MM HH:mm' }}</span>
                    <p class="afo-caption" *ngIf="item.comentario">{{ item.comentario }}</p>
                  </div>

                  <!-- Botón de opciones flotante estilo GaleriaTrabajosComponent -->
                  <button type="button" class="area-foto-options-btn" (click)="openFotoOptions(item); $event.stopPropagation()"
                    title="Opciones" aria-label="Opciones de foto">
                    <ion-icon name="ellipsis-vertical"></ion-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- ── SUB-PASO: Notas y Presupuesto ── -->
        <ng-container *ngIf="subStep === 'notas'">
          <div class="s4-items-wrapper">
            <!-- Rótulo: Registrar Por -->
            <div class="substep-section-heading">
              <ion-icon name="add-circle-outline"></ion-icon>
              <span>Registrar Por:</span>
            </div>

            <!-- Selector horizontal compacto y premium de tipos de estimado/nota -->
            <div class="estimados-type-strip">
              <!-- Planilla -->
              <button type="button" class="medida-pill-btn" (click)="openAddNota('PLANILLA')">
                <div class="mp-icon">
                  <ion-icon name="people-outline"></ion-icon>
                </div>
                <div class="mp-text-block">
                  <span class="mp-type">Planilla</span>
                </div>
              </button>

              <!-- Material -->
              <button type="button" class="medida-pill-btn" (click)="openAddNota('MATERIAL')">
                <div class="mp-icon">
                  <ion-icon name="cube-outline"></ion-icon>
                </div>
                <div class="mp-text-block">
                  <span class="mp-type">Material</span>
                </div>
              </button>

              <!-- Movilidad -->
              <button type="button" class="medida-pill-btn" (click)="openAddNota('MOVILIDAD')">
                <div class="mp-icon">
                  <ion-icon name="flashlight-outline"></ion-icon>
                </div>
                <div class="mp-text-block">
                  <span class="mp-type">Movilidad</span>
                </div>
              </button>

              <!-- Subcontrato -->
              <button type="button" class="medida-pill-btn" (click)="openAddNota('SUBCONTRATO')">
                <div class="mp-icon">
                  <ion-icon name="business-outline"></ion-icon>
                </div>
                <div class="mp-text-block">
                  <span class="mp-type">Subcontrato</span>
                </div>
              </button>

              <!-- Nota -->
              <button type="button" class="medida-pill-btn" (click)="openAddNota('GENERAL')">
                <div class="mp-icon">
                  <ion-icon name="document-text-outline"></ion-icon>
                </div>
                <div class="mp-text-block">
                  <span class="mp-type">Nota</span>
                </div>
              </button>
            </div>

            <!-- Spinner de carga -->
            <div *ngIf="loadingItems" class="s4-loading-container">
              <ion-spinner name="crescent" class="s4-spinner"></ion-spinner>
            </div>

            <!-- Rótulo: Categorías Registradas -->
            <div class="substep-section-heading list-heading" *ngIf="!loadingItems && groupedNotaTypes.length > 0">
              <ion-icon name="folder-open-outline"></ion-icon>
              <span>Resumen por Categoría:</span>
              <span class="heading-badge">{{ groupedNotaTypes.length }}</span>
            </div>

            <!-- Banner Total Estimado del Área -->
            <div class="area-m2-total-badge" *ngIf="!loadingItems && totalEstimadoArea > 0">
              <div class="amtb-left">
                <ion-icon name="cash-outline"></ion-icon>
                <span>Total Estimado del Área:</span>
              </div>
              <span class="amtb-val">${{ totalEstimadoArea | number:'1.2-2' }}</span>
            </div>

            <!-- Carrusel Horizontal de Categorías Registradas -->
            <div class="s4-type-carousel" *ngIf="!loadingItems && groupedNotaTypes.length > 0">
              <div class="s4-type-card" *ngFor="let g of groupedNotaTypes" 
                   [class.active]="selectedNotaTipo === g.key" 
                   (click)="selectNotaTipo(g.key)">
                <div class="stc-header">
                  <div class="stc-icon" [ngClass]="g.key.toLowerCase()">
                    <ion-icon [name]="g.icon"></ion-icon>
                  </div>
                  <span class="stc-badge">{{ g.count }} {{ g.count === 1 ? 'item' : 'items' }}</span>
                </div>
                <div class="stc-body">
                  <span class="stc-label">{{ g.label }}</span>
                  <span class="stc-monto" *ngIf="g.totalMonto > 0">${{ g.totalMonto | number:'1.2-2' }}</span>
                  <span class="stc-monto empty" *ngIf="g.totalMonto === 0 && g.key === 'GENERAL'">Sin monto</span>
                  <span class="stc-monto empty" *ngIf="g.totalMonto === 0 && g.key !== 'GENERAL'">$0.00</span>
                </div>
              </div>
            </div>

            <!-- Empty state -->
            <div class="s4-empty-state" *ngIf="!loadingItems && areaItems.length === 0">
              <ion-icon name="document-text-outline"></ion-icon>
              <p>Sin notas o estimados aún</p>
            </div>

            <!-- Rótulo: Detalle de Ítems -->
            <div class="substep-section-heading list-heading" *ngIf="!loadingItems && filteredNotaItems.length > 0">
              <ion-icon name="list-outline"></ion-icon>
              <span>Detalle de {{ selectedNotaTipo === 'GENERAL' ? 'Notas' : (selectedNotaTipo | titlecase) }}:</span>
              <span class="heading-badge">{{ filteredNotaItems.length }}</span>
            </div>

            <!-- Detalle / Lista de la categoría seleccionada -->
            <div class="s4-item-list" *ngIf="!loadingItems && filteredNotaItems.length > 0">
              <div class="s4-item-card" *ngFor="let item of filteredNotaItems" (click)="openEditNota(item)"
                style="cursor: pointer;">
                <div class="s4-item-icon amber">
                  <ion-icon [name]="(item.tipo === 'GENERAL' || item.tipo === 'NOTA') ? 'document-text-outline' : (item.tipo === 'MATERIAL' ? 'cube-outline' : (item.tipo === 'PLANILLA' ? 'people-outline' : (item.tipo === 'MOVILIDAD' ? 'flashlight-outline' : 'cash-outline')))"></ion-icon>
                </div>
                <div class="s4-item-info">
                  <span class="s4-item-title">{{ item.comentario || item.tipo || 'Sin detalle' }}</span>
                  <span class="s4-item-sub">
                    <ng-container *ngIf="item.costo > 0">Est.: ${{ item.costo | number:'1.2-2' }}</ng-container>
                    <ng-container *ngIf="item.costo <= 0 && (item.tipo === 'GENERAL' || item.tipo === 'NOTA')">Nota descriptiva</ng-container>
                    <ng-container *ngIf="item.costo <= 0 && item.tipo !== 'GENERAL' && item.tipo !== 'NOTA'">Est.: $0.00</ng-container>
                    <ng-container *ngIf="item.subcontratista"> · Sub: {{ item.subcontratista }}</ng-container>
                    <ng-container *ngIf="item.tipo === 'PLANILLA'"> · {{ item.trabajadores }} trab · {{ item.dias }} d</ng-container>
                    <ng-container *ngIf="item.tipo === 'MATERIAL' && item.cantidad > 0"> · Cant: {{ item.cantidad }}</ng-container>
                  </span>
                </div>
                <ion-button fill="clear" (click)="$event.stopPropagation(); deleteAreaItem(item)">
                  <ion-icon name="trash-outline" color="danger" slot="icon-only"></ion-icon>
                </ion-button>
              </div>
            </div>
          </div>
        </ng-container>

      </div><!-- /SUB-PASOS -->

    </div>
  </ion-content>

  <!-- ── FOOTER DE ACCIONES ──────────────────────────────────────────── -->
  <div class="wizard-footer">

    <!-- Indicadores de paso (dots) en la izquierda -->
    <div class="step-dots" *ngIf="currentStep > 0">
      <div class="dot" *ngFor="let i of [1,2,3,4]" [class.active]="i === currentStep" [class.done]="i < currentStep">
      </div>
    </div>

    <!-- Botones agrupados en la derecha estirándose proporcionalmente -->
    <div class="wiz-actions-group">

      <!-- Botones en Paso 0 (Listo y Nuevo Ítem) -->
      <div class="step0-actions-row" *ngIf="currentStep === 0 && subStep === ''" style="display: flex; gap: 10px; width: 100%;">
        <button type="button" class="wiz-prev-btn" (click)="finalizar()" style="flex: 1; height: 52px; border-radius: 16px;">
          <ion-icon name="checkmark-done-outline"></ion-icon>
          <span>Listo</span>
        </button>
        <button type="button" class="wiz-next-btn" (click)="startNewArea()" style="flex: 1.4; height: 52px; border-radius: 16px; margin: 0;">
          <span>Nuevo Ítem</span>
          <ion-icon name="add-circle-outline"></ion-icon>
        </button>
      </div>

      <!-- Atrás (pasos 2, 3 y 4, o paso 1 en modo edit) solo en wizard de pasos -->
      <button *ngIf="subStep === '' && ((currentStep > 1 && currentStep <= 4) || (currentStep === 1 && mode === 'edit'))"
        (click)="prevStep()" class="wiz-prev-btn" style="flex: 1; width: 100%;">
        <ion-icon name="arrow-back-outline"></ion-icon>
        <span>Atrás</span>
      </button>

      <!-- Continuar / Siguiente (pasos 1, 2 y 3) -->
      <button class="wiz-next-btn" *ngIf="currentStep > 0 && currentStep < 4" [disabled]="!canAdvance()"
        (click)="nextStep()" style="margin: 0; flex: 1; width: 100%; height: 52px; border-radius: 16px;">
        <span *ngIf="currentStep === 1">Siguiente</span>
        <span *ngIf="currentStep !== 1">Continuar</span>
        <ion-icon [name]="(currentStep === 1 && mode === 'add' && !areaSaved) ? 'sparkles' : 'arrow-forward-outline'"></ion-icon>
      </button>

      <!-- Guardar Ítem (paso 4) -->
      <button class="wiz-save-btn" *ngIf="currentStep === 4" [disabled]="isSaving || !isFormValid()"
        (click)="nextStep()" style="margin: 0; flex: 1; width: 100%;">
        <ion-spinner *ngIf="isSaving" name="crescent"></ion-spinner>
        <ion-icon *ngIf="!isSaving" name="save-outline"></ion-icon>
        <span>{{ isSaving ? 'Guardando...' : 'Guardar Ítem' }}</span>
      </button>

    </div>
  </div>

</div>